<template>
    <div class="card card--news card--kb">
        <router-link :to="{ name: 'view-post-with-category', params: { group: group.slug, post: post.slug, category: category.slug }}">
            <div class="starts" v-if="group.type == 4 && post.event">{{ formatDate(post.event.starts) }} <span>(in {{ formatDistance(post.event.starts) }})</span></div>
            <h2>{{ post.title }}</h2>
            <p>{{ post.excerpt || post.dynamic_excerpt }}</p>
        </router-link>

        <div v-if="post.updated_at">
            <div class="views">
                <i class="icon ion-md-eye"></i> {{ post.read_by_count }}
            </div>
            <div class="byline">
                <div>Updated {{ lastUpdatedTime }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import { format, formatDistance, parse, formatDistanceToNow } from 'date-fns';

    export default {
        props: ['post', 'group', 'contain', 'featured', 'category'],
        data(){
            return {
                currentTime: new Date()
            }
        },
        created() {

        },
        computed: {
            lastUpdatedTime: function(){
                var date = parse(this.post.updated_at, 'yyyy-MM-dd HH:mm:ss', this.currentTime);
                return formatDistanceToNow(date, {includeSeconds: true, addSuffix: true});
            },
        },
        methods: {
            formatDate(date){
                if(date){
                    date = parse(date, 'yyyy-MM-dd HH:mm:ss', new Date());
                    if(this.group.type == 4){
                        return format(date, 'E do LLL yyyy');
                    }

                    return format(date, 'do LLL yyyy');
                }
            },
            formatDistance(date){
                if(date){
                    date = parse(date, 'yyyy-MM-dd HH:mm:ss', new Date());
                    return formatDistance(date, new Date());
                }
            }
        }
    }
</script>

<style scoped>
    .card--kb h2{
        font-size: 15px;
    }
    .card--kb .byline, .card--kb .views{
        font-size: 11px;
        color: #adadad;
        min-height: auto;
    }
    .card--kb .views{
        margin-bottom: 5px;
    }
    .card--kb .views i{
        margin-right: 5px;
    }
</style>